<template>
  <div class="appx">
    <div class="app-left app-col">
      <center><img src="./assets/images/logo.png" /></center>
      <br /><br /><br />
      <br />Traffic Distillery.com<br /><br />Just smart kids <br /><br /><br />
      <h5>
        <font color="red"></font>
      </h5>
    </div>
    <div class="app-main app-col">
      <router-view></router-view>
    </div>
    <div class="app-menu">
      <MenuRight1 />
    </div>
  </div>
</template>
<script>
import MenuRight1 from "./components/menu_manual_work.vue";
export default {
  components: {
    MenuRight1
  }
};
</script>
<style lang="scss">
@import "./assets/styles/global.scss";
</style>
